import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Breadcrumbs from '../../../components/ui/Breadcrumbs';

const ProjectFormHeader = ({ 
  isEditing = false, 
  projectTitle = '', 
  onSave, 
  onPreview, 
  onCancel,
  isSaving = false,
  hasUnsavedChanges = false 
}) => {
  return (
    <div className="bg-card border-b border-border">
      <div className="px-6 py-4">
        {/* Breadcrumbs */}
        <div className="mb-4">
          <Breadcrumbs />
        </div>

        {/* Header Content */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          {/* Title Section */}
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="FolderPlus" size={24} color="white" />
            </div>
            
            <div>
              <h1 className="text-2xl font-bold text-foreground font-arabic">
                {isEditing ? 'تحرير المشروع' : 'مشروع جديد'}
              </h1>
              <p className="text-sm text-muted-foreground font-caption">
                {isEditing 
                  ? `تحرير: ${projectTitle || 'مشروع بدون عنوان'}`
                  : 'إنشاء مشروع جديد للاتحاد'
                }
              </p>
              {hasUnsavedChanges && (
                <div className="flex items-center space-x-2 mt-1">
                  <div className="w-2 h-2 bg-warning rounded-full animate-pulse" />
                  <span className="text-xs text-warning font-medium">
                    تغييرات غير محفوظة
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center space-x-3">
            <Button
              variant="ghost"
              size="sm"
              onClick={onCancel}
              iconName="X"
              iconPosition="left"
              iconSize={16}
              className="text-muted-foreground hover:text-foreground"
            >
              إلغاء
            </Button>

            <Button
              variant="outline"
              size="sm"
              onClick={onPreview}
              iconName="Eye"
              iconPosition="left"
              iconSize={16}
              className="hidden sm:flex"
            >
              معاينة
            </Button>

            <Button
              variant="secondary"
              size="sm"
              onClick={() => onSave('draft')}
              iconName="Save"
              iconPosition="left"
              iconSize={16}
              loading={isSaving}
              disabled={isSaving}
            >
              حفظ كمسودة
            </Button>

            <Button
              variant="default"
              size="sm"
              onClick={() => onSave('publish')}
              iconName="Upload"
              iconPosition="left"
              iconSize={16}
              loading={isSaving}
              disabled={isSaving}
            >
              نشر المشروع
            </Button>
          </div>
        </div>

        {/* Auto-save Indicator */}
        <div className="mt-4 flex items-center justify-between text-xs text-muted-foreground">
          <div className="flex items-center space-x-2">
            <Icon name="Clock" size={14} />
            <span>آخر حفظ تلقائي: منذ دقيقتين</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <Icon name="Wifi" size={14} />
            <span>متصل</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectFormHeader;